import dynamic from "next/dynamic";

export const TrackingLoader = dynamic(
  () => import("./TrackingLoaderComponent"),
  { ssr: false }
);
